__turbopack_context__.v({
  "chip-selector": "ChipSelector-module-scss-module__e_WKlG__chip-selector",
});
